import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/id.ts
var add = "Tambah";
var remove = "Hapus";
var removeAll = "Hapus semua";
var incomplete = "Maaf, tidak semua bidang formulir terisi dengan benar";
var submit = "Kirim";
var noFiles = "Tidak ada file yang dipilih";
var moveUp = "Pindah ke atas";
var moveDown = "Pindah ke bawah";
var isLoading = "Memuat...";
var loadMore = "Muat lebih";
var next = "Berikutnya";
var prev = "Sebelumnya";
var addAllValues = "Tambahkan semua nilai";
var addSelectedValues = "Tambahkan nilai yang dipilih";
var removeAllValues = "Hapus semua nilai";
var removeSelectedValues = "Hapus nilai yang dipilih";
var chooseDate = "Pilih tanggal";
var changeDate = "Ubah tanggal";
var close = "Tutup";
var open = "Buka";
var accepted = function({
  name
}) {
  return `Tolong terima kolom ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nilainya harus lebih dari waktu ${date(args[0])}.`;
  }
  return `${sentence(name)} harus berisi waktu di masa depan.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} hanya bisa diisi huruf alfabet.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} hanya bisa diisi huruf dan angka.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} hanya boleh berisi huruf dan spasi..`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} harus berisi karakter abjad.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} harus mengandung huruf atau angka.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} harus berisi huruf atau spasi.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} harus berisi simbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} harus berisi huruf besar.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} harus berisi huruf kecil.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} harus berisi angka.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} harus berupa simbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} hanya dapat berisi huruf besar.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} hanya dapat berisi huruf kecil.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nilainya harus kurang dari waktu ${date(args[0])}.`;
  }
  return `${sentence(name)} harus berisi waktu yang sudah lampau.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Kolom ini tidak diisi dengan benar sehingga tidak bisa dikirim`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} harus bernilai diantara ${a} dan ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nilainya tidak cocok.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} waktu tidak cocok, mohon gunakan format waktu ${args[0]}`;
  }
  return "Kolom ini tidak diisi dengan benar sehingga tidak bisa dikirim";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} harus diantara waktu ${date(args[0])} dan waktu ${date(args[1])}`;
};
var email = "Tolong tulis alamat email yang benar.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} nilainya tidak berakhiran dengan ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} adalah nilai yang tidak diizinkan.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} nilainya setidaknya berisi satu karakter.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} jumlah karakternya harus kurang dari atau sama dengan ${max2} karakter.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} harus ${max2} karakter panjang.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} jumlah karakternya harus lebih dari atau sama dengan ${min2} karakter.`;
  }
  return `${sentence(name)} jumlah karakternya hanya bisa antara ${min2} dan ${max2} karakter.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nilainya tidak diizinkan.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Tidak bisa memiliki lebih dari ${args[0]} ${name}.`;
  }
  return `${sentence(name)} harus lebih kecil atau sama dengan ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Format file tidak diizinkan";
  }
  return `${sentence(name)} hanya bisa bertipe: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Tidak boleh kurang dari ${args[0]} ${name}.`;
  }
  return `${sentence(name)} setidaknya harus berisi ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” adalah nilai yang tidak diperbolehkan untuk ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} harus berupa angka.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" atau ")} diperlukan`;
};
var required = function({
  name
}) {
  return `${sentence(name)} harus diisi.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} tidak dimulai dengan ${list(args)}.`;
};
var url = function() {
  return `Harap masukkan URL yang valid.`;
};
var invalidDate = "Tanggal yang dipilih tidak valid.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var id_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, id_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=id.mjs.map